import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { TempStateService } from '../../core/navigation/tempState.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ChangePasswordDTO } from 'src/app/models/changepassword-dto.model';
import { ApiService } from 'src/app/services/http/api.service';
import Validation from 'src/app/utils/validation';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogService } from '@progress/kendo-angular-dialog';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';

@Component({
  selector: 'app-change-password',
  templateUrl: './changepassword.component.html'
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {
  @ViewChild("password") passwordInput: TextBoxComponent | undefined;
  @ViewChild("passwordRewrite") passwordInputRe: TextBoxComponent | undefined;
  @ViewChild("passwordOld") passwordInputOld: TextBoxComponent | undefined;

  formGroup: FormGroup;
  isLoadingResults: boolean = false;
  public errorMessage: string = '';
  returnUrl: string = '';
  public guid: string = '';
  isPasswordVisible: boolean = false;
  isPasswordRewriteVisible: boolean = false;
  isPasswordOldVisible: boolean = false;
  public customMsgService: CustomMessagesService;

  constructor(
    public msgService: MessageService,
    private auth: AuthService,
    private router: Router,
    private stateService: TempStateService, private api: ApiService, private formBuilder: FormBuilder
    , private notificationService: NotificationService, private dialogService: DialogService) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.formGroup = new FormGroup(
      {
        passwordOld: new FormControl(null, Validators.required),
        password: new FormControl(null, Validators.required),
        passwordRewrite: new FormControl(null, Validators.required)
      },
      {
        validators: [Validation.match('password', 'passwordRewrite')]
      }
    );
  }
  ngAfterViewInit(): void {
    this.hidePassword();
    this.hidePasswordRe();
    this.hidePasswordOld();
  }

  ngOnInit(): void {
    this.hidePassword();
    this.hidePasswordRe();
    this.hidePasswordOld();
    this.returnUrl = this.stateService.oldUrl || '/';
  }




  loginPage() {
    this.router.navigateByUrl('login');
  }
  onSubmit() {
    if (this.formGroup.dirty && this.formGroup.valid) {
      const dto =
        {
          OldPass: this.formGroup.controls['passwordOld'].value,
          NewPass: this.formGroup.controls['password'].value,
          NewPassConfirm: this.formGroup.controls['passwordRewrite'].value,
        } as ChangePasswordDTO;
      this.api
        .postRequest<BaseHttpResponse<ChangePasswordDTO>>(
          "Utilizador/AlterarPassword",
          dto
        )
        .then((data) => {
          if (data.ok) {
            this.notificationService.show({
              content: this.customMsgService.translate('passwordAlteradaComSucesso'),
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 4000
            });
            this.formGroup.controls['passwordOld'].setValue('');
            this.formGroup.controls['password'].setValue('');
            this.formGroup.controls['passwordRewrite'].setValue('');
            this.formGroup.markAsPristine();
            this.formGroup.markAsUntouched();
            this.isLoadingResults = true;
          } else {
            this.notificationService.show({
              content: data.message,
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 4000
            });
          }
        })
        .catch((err) => {
          this.notificationService.show({
            content: 'internal server error',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'error', icon: true },
            hideAfter: 2000
          });
        });
    } else {
    }
  }

  selectedChange() {
    if (this.isPasswordVisible == true)
      this.hidePassword();
    else
      this.showPassword();
  }

  selectedChangeRe() {
    if (this.isPasswordRewriteVisible == true)
      this.hidePasswordRe();
    else
      this.showPasswordRe();
  }

  selectedChangeOld() {
    if (this.isPasswordOldVisible == true)
      this.hidePasswordOld();
    else
      this.showPasswordOld();
  }

  showPassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "text";
      this.isPasswordVisible = true;
      ;
    }
  }

  hidePassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "password";
      this.isPasswordVisible = false;
    }
  }

  showPasswordRe() {
    if (this.passwordInputRe) {
      this.passwordInputRe.input.nativeElement.type = "text";
      this.isPasswordRewriteVisible = true;
      ;
    }
  }

  hidePasswordRe() {
    if (this.passwordInputRe) {
      this.passwordInputRe.input.nativeElement.type = "password";
      this.isPasswordRewriteVisible = false;
    }
  }

  showPasswordOld() {
    if (this.passwordInputOld) {
      this.passwordInputOld.input.nativeElement.type = "text";
      this.isPasswordOldVisible = true;
      ;
    }
  }

  hidePasswordOld() {
    if (this.passwordInputOld) {
      this.passwordInputOld.input.nativeElement.type = "password";
      this.isPasswordOldVisible = false;

    }
  }
}
